import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Radio,
  DatePicker,
  Select,
  Checkbox,
  Collapse,
  Alert,
  Tooltip,
  Popconfirm,
  Button,
  Table,
  Space,
  Modal,
} from "antd";
import InputCPF from "../InputCpf";

import {
  InfoCircleOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";

import service from "./service";
import { useBloqueioCampos } from "../../hook/Recadastramento/useBloqueioCampos";
import CarteiraTrabalhoForm from "../CarteiraTrabalho/CarteiraTrabalhoForm";

const { Option } = Select;

const IdentificacaoBase = ({
  nomePrefix = [],
  documentoApresentado,
  modoSomenteLeitura,
  desabilitarCampos = false,
  onSearchCPF,
  onClear,
  children,
  form,
  desabilitarCPF,
  recadastramento,
  salvarCarteira,
  excluirCarteira,
  origemCarteira,
}) => {
  const [cores, setCores] = useState([]);
  const [estadosCivis, setEstadosCivis] = useState([]);
  const [grausInstrucao, setGrausInstrucao] = useState([]);
  const [capacidades, setCapacidades] = useState([]);
  const [tipoSanguineos, setTipoSanguineos] = useState([]);
  const [fatorRhs, setFatorRhs] = useState([]);
  const [conselhoProfissionais, setConselhoProfissionais] = useState([]);

  const [listaPaises, setListaPaises] = useState([]);
  const [listaUF, setListaUF] = useState([]);
  const [listaMunicipio, setListaMunicipio] = useState([]);

  const [listaMotivoAlteracaoCadastro, setListaMotivoAlteracaoCadastro] =
    useState([]);

  const { TextArea } = Input;
  const MOTIVO_OUTROS = 3;
  const [valoresOriginais, setValoresOriginais] = useState(null);

  const BRASIL = "BRASIL";

  const [modalCarteiraAberto, setModalCarteiraAberto] =
  useState(false);

  const [carteiraSelecionada, setCarteiraSelecionada] =
  useState(null);

  const getScrollableParent = (node) => {
    if (!node) return document.body;

    let parent = node.parentElement;

    while (parent) {
      const style = window.getComputedStyle(parent);

      const isScrollable =
        (style.overflowY === "auto" || style.overflowY === "scroll") &&
        parent.scrollHeight > parent.clientHeight;

      if (isScrollable) return parent;

      parent = parent.parentElement;
    }

    return document.body;
  };

  const carteiraTrabalho = Form.useWatch(
  [...nomePrefix, "carteiraTrabalho"],
  form
);

  useEffect(() => {
    service
      .listarCores()
      .then((res) => {
        setCores(res.data);
      })
      .catch((err) => console.error("Erro ao carregar cores:", err));

    service
      .listarEstadosCivis()
      .then((res) => {
        setEstadosCivis(res.data);
      })
      .catch((err) => console.error("Erro ao carregar estados civis:", err));

    service
      .listarGrausDeInstrucao()
      .then((res) => {
        setGrausInstrucao(res.data);
      })
      .catch((err) =>
        console.error("Erro ao carregar Graus De Instrução:", err)
      );

    service
      .listarCapacidades()
      .then((res) => {
        setCapacidades(res.data);
      })
      .catch((err) => console.error("Erro ao carregar capacidades:", err));

    /*service
      .listarTipoSanguineo()
      .then((res) => {
        setTipoSanguineos(res.data);
      })
      .catch((err) => console.error("Erro ao carregar tipos Sanguineos:", err));

    service
      .listarFatorRh()
      .then((res) => {
        setFatorRhs(res.data);
      })
      .catch((err) => console.error("Erro ao carregar o fator RH:", err));*/

    service
      .listarConselhoProfissional()
      .then((res) => {
        setConselhoProfissionais(res.data);
      })
      .catch((err) => console.error("Erro ao carregar o fator RH:", err));

    service
      .listarMotivoAlteracaoCadastro()
      .then((res) => {
        setListaMotivoAlteracaoCadastro(res.data);
      })
      .catch((err) =>
        console.error("Erro ao carregar Motivo Alteração do Cadastro:", err)
      );
  }, []);

  useEffect(() => {
    const inicializarFormulario = async () => {
      try {
        const res = await service.listarPais();
        const paises = res.data;
        setListaPaises(paises);

        const brasil = paises.find((p) => p.nome.toUpperCase() === "BRASIL");
        const paisAtual = form.getFieldValue([...nomePrefix, "pais"]);
        const cidadeAtual = form.getFieldValue([...nomePrefix, "municipio"]);

        if (!cidadeAtual && brasil) {
          form.setFieldsValue({
            [nomePrefix]: {
              pais: "BRASIL",
              uf: null,
              municipio: null,
            },
          });
          carregarUFsPorPais("BRASIL");
        } else {
          const paisNome = cidadeAtual?.uf?.pais?.nome || paisAtual || "BRASIL";
          carregarUFsPorPais(paisNome);
          carregarOpcoesCidade(cidadeAtual?.uf?.sigla);
          form.setFieldValue([...nomePrefix, "pais"], paisNome);
          form.setFieldValue([...nomePrefix, "uf"], cidadeAtual?.uf?.sigla);
          form.setFieldValue([...nomePrefix, "municipio"], cidadeAtual);
        }
      } catch (error) {
        setListaPaises([]);
      }
    };

    inicializarFormulario();
  }, []);

  const carregarUFsPorPais = (pais) => {
    if (!pais) {
      setListaUF([]);
      return;
    }

    service
      .listarUFsPorPais(pais)
      .then((res) => setListaUF(res.data))
      .catch(() => setListaUF([]));
  };

  const onChangePais = (value) => {
    const ufAtual = form.getFieldValue([...nomePrefix, "uf"]);
    const municipioAtual = form.getFieldValue([...nomePrefix, "municipio"]);

    // Só limpa se o usuário realmente trocou o país
    if (ufAtual || municipioAtual) {
      form.setFieldValue([...nomePrefix, "uf"], null);
      form.setFieldValue([...nomePrefix, "municipio"], null);
    }

    carregarUFsPorPais(value);
  };

  const carregarOpcoesCidade = (uf) => {
    if (!uf) {
      setListaMunicipio([]);
      return;
    }

    service
      .listarCidadesPorUf(uf)
      .then((res) => {
        setListaMunicipio(res.data);
      })
      .catch(() => setListaMunicipio([]));
  };

  const onChangeUF = (value) => {
    form.setFieldValue([...nomePrefix, "municipio"], null);
    carregarOpcoesCidade(value);
  };

  const paisWatch = Form.useWatch([...nomePrefix, "pais"], form);
  const municipioWatch = Form.useWatch([...nomePrefix, "municipio"], form);
  const ufWatch = Form.useWatch([...nomePrefix, "uf"], form);

  useEffect(() => {
    if (!paisWatch) {
      form.setFieldValue([...nomePrefix, "pais"], BRASIL);
      carregarUFsPorPais(BRASIL);
    }
  }, [paisWatch]);

  useEffect(() => {
    if (paisWatch) {
      carregarUFsPorPais(paisWatch);
    } else {
      setListaUF([]);
    }
  }, [paisWatch]);

  useEffect(() => {
    if (ufWatch) {
      carregarOpcoesCidade(ufWatch);
    } else {
      setListaMunicipio([]);
    }
  }, [ufWatch]);

  useEffect(() => {
    if (!municipioWatch?.uf) return;

    const paisNome = municipioWatch.uf.pais?.nome || BRASIL;
    const ufSigla = municipioWatch.uf.sigla;

    carregarUFsPorPais(paisNome);
    carregarOpcoesCidade(ufSigla);

    // Só seta se ainda não estiver setado
    if (!form.getFieldValue([...nomePrefix, "uf"])) {
      form.setFieldValue([...nomePrefix, "uf"], ufSigla);
    }
  }, [municipioWatch]);

  const { camposBloqueados, alteracaoCadastro } = useBloqueioCampos({
    form,
    nomePrefix,
    modoSomenteLeitura,
    desabilitarCampos,
    recadastramento,
  });

  useEffect(() => {
    if (!alteracaoCadastro) {
      form.setFieldsValue({
        [nomePrefix.join(".")]: {
          codigoMotivoAlteracaoCadastro: undefined,
          justificativaAlteracaoCadastro: undefined,
        },
      });
      form.setFieldsValue(valoresOriginais);
    }
  }, [alteracaoCadastro, valoresOriginais]);

  const motivoAlteracao = Form.useWatch(
    [...nomePrefix, "codigoMotivoAlteracaoCadastro"],
    form
  );

  const isOutros = motivoAlteracao === MOTIVO_OUTROS;

  useEffect(() => {
    if (!isOutros) {
      form.setFieldValue(
        [...nomePrefix, "justificativaAlteracaoCadastro"],
        undefined
      );
    }
  }, [isOutros]);

  useEffect(() => {
    if (!valoresOriginais) {
      const valoresAtuais = form.getFieldsValue(true);

      setValoresOriginais(valoresAtuais);
    }
  }, [form, valoresOriginais]);

  const isIdentidade = documentoApresentado === "CARTEIRA DE IDENTIDADE";
  const isPassaporte = documentoApresentado === "PASSAPORTE";
  const isCarteiraProfissional = documentoApresentado === "CARTEIRA PROFISSIONAL";
  const isHabilitacao = documentoApresentado === "CARTEIRA NACIONAL DE HABILITAÇÃO";
  const isCarteiraTrabalho = documentoApresentado === "CARTEIRA DE TRABALHO";

  useEffect(() => {
    if (isIdentidade) {
      setTimeout(() => {
        form.setFieldsValue({
          [nomePrefix[0]]: {
            identidade: undefined,
            expedicaoIdentidade: undefined,
            orgaoExpedidorIdentidade: undefined,
          },
        });
      }, 0);
    }

    if (isPassaporte) {
      setTimeout(() => {
        form.setFieldsValue({
          [nomePrefix[0]]: {
            passaporte: undefined,
            expedicaoPassaporte: undefined,
            validadePassaporte: undefined,
          },
        });
      }, 0);
    }

    if (isCarteiraProfissional) {
      setTimeout(() => {
        form.setFieldsValue({
          [nomePrefix[0]]: {
            conselhoProfissional: undefined,
            carteiraProfissional: undefined,
            expedicaoCarteiraProfissional: undefined,
            validadeCarteiraProfissional: undefined,
          },
        });
      }, 0);
    }

    if (isHabilitacao) {
      setTimeout(() => {
        form.setFieldsValue({
          [nomePrefix[0]]: {
            carteiraHabilit: undefined,
            emissaoHabilit: undefined,
            validadeHabilit: undefined,
            localEmissaoHabilit: undefined,
          },
        });
      }, 0);
    }

    if (isCarteiraTrabalho) {
      setTimeout(() => {
        form.setFieldsValue({
          [nomePrefix[0]]: {
            numero: undefined,
            serie: undefined,
            dataExpedicao: undefined,
            localExpedicao: undefined,
          },
        });
      }, 0);
    }
  }, []);

  return (
    <>
      {recadastramento && (
        <Collapse ghost activeKey={alteracaoCadastro ? ["1"] : []}>
          <Collapse.Panel
            key="1"
            header={
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <Form.Item
                  name={[...nomePrefix, "alteracaoCadastro"]}
                  valuePropName="checked"
                  style={{ marginBottom: 0 }}
                >
                  <Checkbox />
                </Form.Item>

                <Tooltip title="Use apenas quando for necessário alteração nos dados de Identificação do Segurado.">
                  <span
                    style={{
                      fontWeight: 600,
                      color: "#0a3e86",
                      fontSize: "20px",
                      cursor: "help",
                    }}
                  >
                    <b>Alteração de Cadastro</b>

                    {alteracaoCadastro && (
                      <span style={{ color: "#faad14", marginLeft: 6 }}>
                        (ativo)
                      </span>
                    )}
                  </span>
                </Tooltip>

                <Tooltip title="Use apenas quando for necessário alteração nos dados de Identificação do Segurado.">
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
            }
            collapsible="disabled"
          >
            <Alert
              type="warning"
              showIcon
              message="Esta ação registra uma alteração oficial no cadastro do segurado."
              description="Use apenas quando for necessário alteração nos dados de Identificação do Segurado."
              style={{ marginBottom: 12 }}
            />

            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name={[...nomePrefix, "codigoMotivoAlteracaoCadastro"]}
                  label="Motivo da alteração do Cadastro"
                  dependencies={[[...nomePrefix, "alteracaoCadastro"]]}
                  rules={[
                    ({ getFieldValue }) => ({
                      required: !!getFieldValue([
                        ...nomePrefix,
                        "alteracaoCadastro",
                      ]),
                      message: "O motivo da alteração é obrigatório",
                    }),
                  ]}
                >
                  <Select
                    placeholder="Selecione"
                    allowClear
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {listaMotivoAlteracaoCadastro.map((m, index) => {
                      if (!m.sigla?.trim()) return null;

                      return (
                        <Option key={m.codigo} value={m.codigo}>
                          {m.sigla}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              {isOutros && (
                <Col span={18}>
                  <Form.Item
                    name={[...nomePrefix, "justificativaAlteracaoCadastro"]}
                    label="Justificativa da alteração"
                    rules={[
                      {
                        required: true,
                        message: "A justificativa é obrigatória",
                      },
                    ]}
                  >
                    <TextArea
                      rows={4}
                      maxLength={500}
                      showCount
                      placeholder="Descreva a justificativa da alteração"
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Collapse.Panel>
        </Collapse>
      )}

      <Row
        gutter={12}
        disabled={modoSomenteLeitura}
        style={{ marginTop: "1.5%" }}
      >
        <Col span={6}>
          <Form.Item
            name={[...nomePrefix, "cpf"]}
            label="CPF"
            rules={[{ required: true }]}
          >
            <InputCPF
              onSearch={onSearchCPF}
              onClear={onClear}
              readOnly={desabilitarCPF}
              showSearch={!desabilitarCPF}
            />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[...nomePrefix, "dataDeNascimento"]}
            label="Nascimento"
            rules={[{ required: true }]}
          >
            <DatePicker
              disabled={recadastramento}
              style={{ width: "100%" }}
              format="DD/MM/YYYY"
              getPopupContainer={(trigger) => getScrollableParent(trigger)}
            />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[...nomePrefix, "cor"]}
            label="Cor"
            rules={[{ required: true }]}
          >
            <Select
              disabled={camposBloqueados}
              placeholder="Selecione a cor"
              allowClear
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {cores.map((cor, index) => (
                <Option key={index} value={index}>
                  {cor.sigla}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[...nomePrefix, "sexo"]}
            label="Sexo"
            rules={[{ required: true }]}
          >
            <Radio.Group>
              <Radio disabled={camposBloqueados} value="F">Feminino</Radio>
              <Radio disabled={camposBloqueados} value="M">Masculino</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[...nomePrefix, "estadoCivil", "id"]}
            label="Estado Civil"
            rules={[{ required: true }]}
          >
            <Select
              disabled={camposBloqueados}
              placeholder="Selecione"
              allowClear
              getPopupContainer={(trigger) => getScrollableParent(trigger)}
              onChange={(value) => {
                if (!value) {
                  form.setFieldValue([...nomePrefix, "estadoCivil"], undefined);
                  return;
                }

                const objetoCompleto = estadosCivis.find((m) => m.id === value);

                form.setFieldValue(
                  [...nomePrefix, "estadoCivil"],
                  objetoCompleto
                );
              }}
            >
              {estadosCivis.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.nome}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={10}>
          <Form.Item
            name={[...nomePrefix, "nome"]}
            label="Nome"
            rules={[{ required: true }]}
          >
            <Input disabled={camposBloqueados} />
          </Form.Item>
        </Col>

        <Col span={10}>
          <Form.Item
            name={[...nomePrefix, "mae"]}
            label="Nome da Mãe"
            rules={[{ required: true }]}
          >
            <Input disabled={camposBloqueados} />
          </Form.Item>
        </Col>

        <Col span={10}>
          <Form.Item name={[...nomePrefix, "pai"]} label="Nome do Pai">
            <Input disabled={camposBloqueados} />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[...nomePrefix, "grauDeInstrucao", "id"]}
            label="Grau de Instrução"
            rules={[{ required: true }]}
          >
            <Select
              disabled={camposBloqueados}
              placeholder="Selecione"
              allowClear
              getPopupContainer={(trigger) => getScrollableParent(trigger)}
            >
              {grausInstrucao.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.nome}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item
            name={[...nomePrefix, "tipoCapacidade"]}
            label="Capacidade"
            rules={[{ required: true }]}
          >
            <Select
              disabled={camposBloqueados}
              placeholder="Selecione a capacidade"
              allowClear
              getPopupContainer={(trigger) => getScrollableParent(trigger)}
            >
              {capacidades.map((capacidade, index) => (
                <Option key={index} value={capacidade}>
                  {capacidade || "Selecione"}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={2} >
          <Form.Item
          hidden
            name={[...nomePrefix, "tipoSanguineo"]}
            label="Tipo Sanguineo"
          >
            <Select
              disabled={camposBloqueados}
              placeholder="Selecione o tipo sanguineo"
              allowClear
              getPopupContainer={(trigger) => getScrollableParent(trigger)}
            >
              {tipoSanguineos.map((tipoSanguineo, index) => (
                <Option key={index} value={tipoSanguineo}>
                  {tipoSanguineo || "Selecione"}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={2}>
          <Form.Item hidden name={[...nomePrefix, "fatorRH"]} label="Fator RH">
            <Select
              disabled={camposBloqueados}
              placeholder="Selecione o fator RH"
              allowClear
              getPopupContainer={(trigger) => getScrollableParent(trigger)}
            >
              {fatorRhs.map((fatorRh, index) => (
                <Option key={index} value={fatorRh}>
                  {fatorRh || "Selecione"}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={7}>
          <fieldset
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "12px",
              position: "relative",
              marginTop: "4px",
            }}
          >
            <legend
              style={{
                fontSize: "13px",
                padding: "0 8px",
                fontWeight: "600",
              }}
              rules={[{ required: true }]}
            >
              Naturalidade
            </legend>

            <Row gutter={12}>
              {/* País */}
              <Col span={8}>
                <Form.Item
                  label="País"
                  name={[...nomePrefix, "pais"]}
                  rules={[{ required: true }]}
                >
                  <Select
                    disabled={camposBloqueados}
                    placeholder="Selecione"
                    allowClear
                    onChange={onChangePais}
                    getPopupContainer={(trigger) =>
                      getScrollableParent(trigger)
                    }
                  >
                    {listaPaises?.map((item) => (
                      <Option key={item.nome} value={item.nome}>
                        {item.nome}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* UF */}
              <Col span={4}>
                <Form.Item
                  label="UF"
                  name={[...nomePrefix, "uf"]}
                  rules={[{ required: true, message: "UF é obrigatória." }]}
                >
                  <Select
                    placeholder="Selecione"
                    allowClear
                    disabled={
                      !form.getFieldValue([...nomePrefix, "pais"]) ||
                      modoSomenteLeitura ||
                      camposBloqueados
                    }
                    onChange={onChangeUF}
                    getPopupContainer={(trigger) =>
                      getScrollableParent(trigger)
                    }
                  >
                    {listaUF?.map((uf) => {
                      const sigla = uf.sigla?.trim();

                      return (
                        <Option key={sigla || "vazio"} value={sigla || null}>
                          {sigla || "Selecione"}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              {/* Município */}
              <Col span={12}>
                <Form.Item
                  label="Município"
                  name={[...nomePrefix, "municipio"]}
                  rules={[
                    { required: true, message: "Município é obrigatório." },
                  ]}
                  getValueProps={(valor) => {
                    if (!valor) return { value: undefined };

                    return {
                      value: {
                        value: valor.id,
                        label: valor.nome,
                      },
                    };
                  }}
                >
                  <Select
                    placeholder="Selecione"
                    allowClear
                    labelInValue
                    optionLabelProp="label"
                    disabled={
                      !form.getFieldValue([...nomePrefix, "uf"]) ||
                      modoSomenteLeitura ||
                      camposBloqueados
                    }
                    onChange={(option) => {
                      if (!option) {
                        form.setFieldValue([...nomePrefix, "municipio"], null);
                        return;
                      }

                      const objetoCompleto = listaMunicipio.find(
                        (m) => m.id === option.value
                      );

                      form.setFieldValue(
                        [...nomePrefix, "municipio"],
                        objetoCompleto
                      );
                    }}
                    getPopupContainer={(trigger) =>
                      getScrollableParent(trigger)
                    }
                  >
                    {listaMunicipio?.map((m) => (
                      <Select.Option key={m.id} value={m.id} label={m.nome}>
                        {m.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Col>

        <Col span={9}>
          <fieldset
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "12px",
              position: "relative",
              marginTop: "4px",
            }}
          >
            <legend
              style={{
                fontSize: "13px",
                padding: "0 8px",
                fontWeight: "600",
              }}
            >
              Titulo de Eleitor
            </legend>

            <Row gutter={9}>
              {/* Número */}
              <Col span={8}>
              <Form.Item
                    name={[...nomePrefix, "tituloEleitor"]}
                    label="Número"
                    getValueFromEvent={(e) =>
                      e.target.value
                        .replace(/[^0-9 ]/g, "") 
                        .replace(/\s+/g, " ")
                        .slice(0, 20)
                    }
                    rules={[
                      { pattern: /^(?=.*\d)[0-9 ]+$/,  message: "Deve conter pelo menos um número" },
                      { max: 20, message: "Máximo de 20 números" },
                    ]}
                  >
                     <Input
                        maxLength={20}
                        disabled={camposBloqueados}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) e.preventDefault();
                        }}
                      />
                  </Form.Item>
              </Col>

              {/* Zona */}
              <Col span={5}>
                <Form.Item
                  name={[...nomePrefix, "zonaTitEleitor"]}
                  label="Zona"
                  rules={[
                    { max: 8, message: "Máximo de 8 números" },
                  ]}
                >
                  <Input maxLength={8} disabled={camposBloqueados} />
                </Form.Item>
              </Col>

              {/* Seção */}
              <Col span={5}>
                <Form.Item
                  name={[...nomePrefix, "secaoTitEleitor"]}
                  label="Seção"
                  rules={[
                    { max: 10, message: "Máximo de 10 caracteres" },
                  ]}
                >
                  <Input disabled={camposBloqueados} />
                </Form.Item>
              </Col>

              {/* UF */}
              <Col span={4}>
                <Form.Item name={[...nomePrefix, "ufTitEleitor"]} label="UF" rules={[
                    { max: 20, message: "Máximo de 20 caracteres" },
                  ]}>
                  <Input maxLength={120} disabled={camposBloqueados} />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Col>

        {( documentoApresentado === "CARTEIRA DE IDENTIDADE" ||
          modoSomenteLeitura || !recadastramento) && (
          <Col span={7}>
            <fieldset
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "12px",
                position: "relative",
                marginTop: "4px",
              }}
            >
              <legend
                style={{
                  fontSize: "13px",
                  padding: "0 8px",
                  fontWeight: "600",
                }}
              >
                Identidade
              </legend>

              <Row gutter={12}>
                {/* Número */}
                <Col span={8}>
                  <Form.Item
                    name={[...nomePrefix, "identidade"]}
                    label="Número"
                    getValueFromEvent={(e) =>
                      e.target.value
                        .replace(/[^0-9 ]/g, "") 
                        .replace(/\s+/g, " ")
                        .slice(0, 20)
                    }
                    rules={[
                      {
                        required: isIdentidade,
                        message: "Informe o número da identidade",
                      },
                      { pattern: /^(?=.*\d)[0-9 ]+$/,  message: "Deve conter pelo menos um número" },
                      { max: 20, message: "Máximo de 20 números" },
                    ]}
                  >
                     <Input
                        maxLength={20}
                        disabled={camposBloqueados && !isIdentidade}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) e.preventDefault();
                        }}
                      />
                  </Form.Item>
                </Col>

                {/* Dt.Expedição */}
                <Col span={7}>
                  <Form.Item
                    rules={[
                      {
                        required: isIdentidade,
                        message: "Informe a Data Expedição",
                      },
                    ]}
                    name={[...nomePrefix, "expedicaoIdentidade"]}
                    label="Data Expedição"
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isIdentidade }
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                    />
                  </Form.Item>
                </Col>

                {/* Orgão */}
                <Col span={9}>
                  <Form.Item
                    name={[...nomePrefix, "orgaoExpedidorIdentidade"]}
                    label="Orgão"
                    rules={[
                      {
                        required: isIdentidade,
                        message: "Informe o Orgão",
                      },
                      { max: 10, message: "Máximo de 10 caracteres." },
                    ]}
                  >
                    <Input maxLength={10} disabled={camposBloqueados && !isIdentidade } />
                  </Form.Item>
                </Col>
              </Row>
            </fieldset>
          </Col>
        )}

        <Col span={7}>
          <fieldset
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "12px",
              position: "relative",
              marginTop: "4px",
            }}
          >
            <legend
              style={{
                fontSize: "13px",
                padding: "0 8px",
                fontWeight: "600",
              }}
            >
              Certidão de Nascimento
            </legend>

            <Row gutter={12}>
              {/* Número */}
              <Col span={8}>

                <Form.Item
                  name={[...nomePrefix, "certidaoNasc"]}
                  label="Número"
                  rules={[
                    { max: 32, message: "Máximo de 32 caracteres." },
                  ]}
                  getValueFromEvent={(e) =>
                  e.target.value
                  .replace(/[^0-9 ]/g, "") 
                    .replace(/\s+/g, " ")
                    .slice(0, 20)
                  }
                >
                  <Input
                    maxLength={32}
                    disabled={camposBloqueados}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) e.preventDefault();
                    }}
                  />
                </Form.Item>
              </Col>

              {/* Livro */}
              <Col span={4}>
                <Form.Item
                  name={[...nomePrefix, "livroCertidaoNasc"]}
                  label="Livro"
                  rules={[
                    {max : 20,message:"Máximo de 20 caracteres."},
                  ]}
                >
                  <Input maxLength={20} disabled={camposBloqueados} />
                </Form.Item>
              </Col>

              {/* Folha */}
              <Col span={12}>
                <Form.Item
                  name={[...nomePrefix, "folhaCertidaoNasc"]}
                  label="Folha"
                  rules={[
                    {max : 20,message:"Máximo de 20 caracteres."},
                  ]}
                >
                  <Input maxLength={20} disabled={camposBloqueados} />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Col>

        {(documentoApresentado === "CARTEIRA NACIONAL DE HABILITAÇÃO" ||
          modoSomenteLeitura || !recadastramento) && (
          <Col span={12}>
            <fieldset
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "12px",
                position: "relative",
                marginTop: "4px",
              }}
            >
              <legend
                style={{
                  fontSize: "13px",
                  padding: "0 8px",
                  fontWeight: "600",
                }}
              >
                Carteira de Habilitação
              </legend>

              <Row gutter={9}>
                {/* Número */}
                <Col span={8}>
                  <Form.Item
                    name={[...nomePrefix, "carteiraHabilit"]}
                    label="Número"
                    rules={[
                      {
                        required: isHabilitacao,
                        message: "Informe o número da Habilitação",
                      },
                      {max : 50,message:"Máximo de 50 caracteres."},
                    ]}
                    getValueFromEvent={(e) =>
                    e.target.value
                    .replace(/[^0-9 ]/g, "") 
                      .replace(/\s+/g, " ")
                      .slice(0, 20)
                    }
                  >
                    <Input
                      maxLength = {50} disabled={camposBloqueados && !isHabilitacao}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                      }}
                    />
                  </Form.Item>

                  
                </Col>

                {/* Data de Emissão */}
                <Col span={5}>
                  <Form.Item
                    name={[...nomePrefix, "emissaoHabilit"]}
                    label="Data de Emissão"
                    dependencies={[...nomePrefix, "validadeHabilit"]}
                    rules={[
                      {
                        required: isHabilitacao,
                        message: "Informe a Data de Emissão",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const validade = getFieldValue([
                            ...nomePrefix,
                            "validadeHabilit",
                          ]);
                          if (
                            !value ||
                            !validade ||
                            value.isSameOrBefore(validade)
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "A data de expedição não pode ser posterior à data de validade."
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isHabilitacao}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                      onChange={() => {
                        form.setFieldsValue({
                          [nomePrefix[0]]: {
                            [nomePrefix[1]]: {
                              validadeHabilit: null,
                            },
                          },
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* data Validade */}
                <Col span={5}>
                  <Form.Item
                    name={[...nomePrefix, "validadeHabilit"]}
                    label="Validade"
                    dependencies={[...nomePrefix, "emissaoHabilit"]}
                    rules={[
                      {
                        required: isHabilitacao,
                        message: "Informe a Data de Validade",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const expedicao = getFieldValue([
                            ...nomePrefix,
                            "emissaoHabilit",
                          ]);

                          // Se expedição existe e validade está vazia → obrigatório
                          if (expedicao && !value) {
                            return Promise.reject(
                              new Error(
                                "A data de validade é obrigatória quando a expedição está preenchida."
                              )
                            );
                          }

                          // Se ambas existem e validade < expedição → erro
                          if (
                            expedicao &&
                            value &&
                            value.isBefore(expedicao, "day")
                          ) {
                            return Promise.reject(
                              new Error(
                                "A validade não pode ser ANTERIO da expedição."
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isHabilitacao}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                      disabledDate={(current) => {
                        const expedicao = form.getFieldValue([
                          ...nomePrefix,
                          "emissaoHabilit",
                        ]);
                        return expedicao && current.isBefore(expedicao, "day");
                      }}
                      defaultPickerValue={form.getFieldValue([
                        ...nomePrefix,
                        "emissaoHabilit",
                      ])}
                    />
                  </Form.Item>
                </Col>

                {/* Local */}
                <Col span={4}>
                  <Form.Item
                    name={[...nomePrefix, "localEmissaoHabilit"]}
                    label="Local de Emissão"
                    rules={[
                      {
                        required: isHabilitacao,
                        message: "Informe o Local da Emissão",
                      },{max : 50,message:"Máximo de 50 caracteres."},]}
                  >
                    <Input maxLength={50} disabled={camposBloqueados && !isHabilitacao} />
                  </Form.Item>
                </Col>
              </Row>
            </fieldset>
          </Col>
        )}

        <Col span={7}>
          <fieldset
            style={{
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "12px",
              position: "relative",
              marginTop: "4px",
            }}
          >
            <legend
              style={{
                fontSize: "13px",
                padding: "0 8px",
                fontWeight: "600",
              }}
            >
              Certidão De Casamento
            </legend>

            <Row gutter={12}>
              {/* Número */}
              <Col span={8}>

                <Form.Item
                    rules ={[
                      {max : 32,message:"Máximo de 32 caracteres."},
                    ]} 
                    name={[...nomePrefix, "certidaoCas"]} 
                    label="Número"
                    getValueFromEvent={(e) =>
                    e.target.value
                    .replace(/[^0-9 ]/g, "") 
                      .replace(/\s+/g, " ")
                      .slice(0, 20)
                    }
                  >
                    <Input
                     maxLength={32} disabled={camposBloqueados}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                      }}
                    />
                </Form.Item>
              </Col>

              {/* Livro */}
              <Col span={4}>
                <Form.Item
                rules ={[
                  {max : 20,message:"Máximo de 20 caracteres."},
                ]}
                  name={[...nomePrefix, "livroCertidaoCas"]}
                  label="Livro"
                >
                  <Input maxLength={20} disabled={camposBloqueados} />
                </Form.Item>
              </Col>

              {/* Folha */}
              <Col span={12}>
                <Form.Item
                rules ={[
                  {max : 20,message:"Máximo de 20 caracteres."},
                ]}
                  name={[...nomePrefix, "folhaCertidaoCas"]}
                  label="Folha"
                >
                  <Input maxLength={20} disabled={camposBloqueados} />
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Col>

        {(documentoApresentado === "PASSAPORTE" || modoSomenteLeitura || !recadastramento) && (
          <Col span={9}>
            <fieldset
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "12px",
                position: "relative",
                marginTop: "4px",
              }}
            >
              <legend
                style={{
                  fontSize: "13px",
                  padding: "0 8px",
                  fontWeight: "600",
                }}
              >
                Passaporte
              </legend>

              <Row gutter={9}>
                {/* Número */}
                <Col span={8}>
                  <Form.Item
                      name={[...nomePrefix, "passaporte"]}
                      label="Número"
                      rules={[
                        {
                          required: isPassaporte,
                          message: "Informe o número do passaporte",
                        },{max : 50,message:"Máximo de 50 caracteres."},
                      ]}
                      getValueFromEvent={(e) =>
                      e.target.value
                      .replace(/[^0-9 ]/g, "") 
                        .replace(/\s+/g, " ")
                        .slice(0, 20)
                      }
                    >
                      <Input
                      maxLength={50} disabled={camposBloqueados && !isPassaporte}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) e.preventDefault();
                        }}
                      />
                  </Form.Item>
                </Col>

                {/* data Expedissão */}
                <Col span={6}>
                  <Form.Item
                    name={[...nomePrefix, "expedicaoPassaporte"]}
                    label="Data Expedição"
                    dependencies={[...nomePrefix, "validadePassaporte"]}
                    rules={[
                      {
                        required: isPassaporte,
                        message: "Informe a data de Validade",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const validade = getFieldValue([
                            ...nomePrefix,
                            "validadePassaporte",
                          ]);
                          if (
                            !value ||
                            !validade ||
                            value.isSameOrBefore(validade)
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "A data de expedição não pode ser posterior à data de validade."
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isPassaporte}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                      onChange={() => {
                        form.setFieldsValue({
                          [nomePrefix[0]]: {
                            [nomePrefix[1]]: {
                              validadePassaporte: null,
                            },
                          },
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Data de Validade */}
                <Col span={5}>
                  <Form.Item
                    name={[...nomePrefix, "validadePassaporte"]}
                    label="Data Validade"
                    dependencies={[...nomePrefix, "expedicaoPassaporte"]}
                    rules={[
                      {
                        required: isPassaporte,
                        message: "Informe a data de expedição",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const expedicao = getFieldValue([
                            ...nomePrefix,
                            "expedicaoPassaporte",
                          ]);

                          // Se expedição existe e validade está vazia → obrigatório
                          if (expedicao && !value) {
                            return Promise.reject(
                              new Error(
                                "A data de validade é obrigatória quando a expedição está preenchida."
                              )
                            );
                          }

                          // Se ambas existem e validade < expedição → erro
                          if (
                            expedicao &&
                            value &&
                            value.isBefore(expedicao, "day")
                          ) {
                            return Promise.reject(
                              new Error(
                                "A validade não pode ser ANTES da expedição."
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isPassaporte}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                      disabledDate={(current) => {
                        const expedicao = form.getFieldValue([
                          ...nomePrefix,
                          "expedicaoPassaporte",
                        ]);
                        return expedicao && current.isBefore(expedicao, "day");
                      }}
                      defaultPickerValue={form.getFieldValue([
                        ...nomePrefix,
                        "expedicaoPassaporte",
                      ])}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </fieldset>
          </Col>
        )}
        {(documentoApresentado === "CARTEIRA PROFISSIONAL" ||
          modoSomenteLeitura || !recadastramento) && (
          <Col span={12}>
            <fieldset
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "12px",
                position: "relative",
                marginTop: "4px",
              }}
            >
              <legend
                style={{
                  fontSize: "13px",
                  padding: "0 8px",
                  fontWeight: "600",
                }}
              >
                Carteira Profissional
              </legend>

              <Row gutter={9}>
                {/* Conselho */}
                <Col span={8}>
                  <Form.Item
                    name={[...nomePrefix, "conselhoProfissional"]}
                    label="Conselho"
                    getValueProps={(valor) => {
                      if (!valor) return { value: undefined };

                      return {
                        value: {
                          value: valor.id,
                          label: valor.sigla,
                        },
                      };
                    }}
                    rules={[
                      {
                        required: isCarteiraProfissional,
                        message: "Informe o Conselho Profissional",
                      },
                    ]}
                  >
                    <Select
                      disabled={camposBloqueados && !isCarteiraProfissional}
                      placeholder="Selecione"
                      allowClear
                      labelInValue
                      optionLabelProp="label"
                      onChange={(option) => {
                        if (!option) {
                          form.setFieldValue(
                            [...nomePrefix, "conselhoProfissional"],
                            null
                          );
                          return;
                        }

                        const objetoCompleto = conselhoProfissionais.find(
                          (m) => m.id === option.value
                        );

                        form.setFieldValue(
                          [...nomePrefix, "conselhoProfissional"],
                          objetoCompleto
                        );
                      }}
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                    >
                      {conselhoProfissionais?.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.sigla}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Número */}
                <Col span={4}>
                  <Form.Item
                        name={[...nomePrefix, "carteiraProfissional"]}
                        label="Número"
                        rules={[
                          {
                            required: isCarteiraProfissional,
                            message: "Informe o Número do Conselho",
                          },
                          {max : 50,message:"Máximo de 50 caracteres."},
                        ]}
                        getValueFromEvent={(e) =>
                        e.target.value
                        .replace(/[^0-9 ]/g, "") 
                          .replace(/\s+/g, " ")
                          .slice(0, 20)
                        }
                      >
                        <Input
                          maxLength={50} disabled={camposBloqueados && !isCarteiraProfissional}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) e.preventDefault();
                          }}
                        />
                  </Form.Item>
                </Col>

                {/* Data Expedição */}
                <Col span={5}>
                  <Form.Item
                    name={[...nomePrefix, "expedicaoCarteiraProfissional"]}
                    label="Data Expedição"
                    dependencies={[
                      ...nomePrefix,
                      "validadeCarteiraProfissional",
                    ]}
                    rules={[
                      {
                        required: isCarteiraProfissional,
                        message: "Informe o Número do Conselho",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const validade = getFieldValue([
                            ...nomePrefix,
                            "validadeCarteiraProfissional",
                          ]);
                          if (
                            !value ||
                            !validade ||
                            value.isSameOrBefore(validade)
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              "A data de expedição não pode ser posterior à data de validade."
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isCarteiraProfissional}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                      onChange={() => {
                        form.setFieldsValue({
                          [nomePrefix[0]]: {
                            [nomePrefix[1]]: {
                              validadeCarteiraProfissional: null,
                            },
                          },
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Data de Validade */}
                <Col span={5}>
                  <Form.Item
                    name={[...nomePrefix, "validadeCarteiraProfissional"]}
                    label="Data Validade"
                    dependencies={[
                      ...nomePrefix,
                      "expedicaoCarteiraProfissional",
                    ]}
                    rules={[
                      {
                        required: isCarteiraProfissional,
                        message: "Informe o Número do Conselho",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const expedicao = getFieldValue([
                            ...nomePrefix,
                            "expedicaoCarteiraProfissional",
                          ]);

                          // Se expedição existe e validade está vazia → obrigatório
                          if (expedicao && !value) {
                            return Promise.reject(
                              new Error(
                                "A data de validade é obrigatória quando a expedição está preenchida."
                              )
                            );
                          }

                          // Se ambas existem e validade < expedição → erro
                          if (
                            expedicao &&
                            value &&
                            value.isBefore(expedicao, "day")
                          ) {
                            return Promise.reject(
                              new Error(
                                "A validade não pode ser ANTES da expedição."
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      disabled={camposBloqueados && !isCarteiraProfissional}
                      style={{ width: "100%" }}
                      format="DD/MM/YYYY"
                      getPopupContainer={(trigger) =>
                        getScrollableParent(trigger)
                      }
                      disabledDate={(current) => {
                        const expedicao = form.getFieldValue([
                          ...nomePrefix,
                          "expedicaoCarteiraProfissional",
                        ]);
                        return expedicao && current.isBefore(expedicao, "day");
                      }}
                      defaultPickerValue={form.getFieldValue([
                        ...nomePrefix,
                        "expedicaoCarteiraProfissional",
                      ])}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </fieldset>
          </Col>
        )}

        {(documentoApresentado === "CARTEIRA DE TRABALHO" ||
          modoSomenteLeitura ||
          !recadastramento) && (
          <CarteiraTrabalhoForm
            form={form}
            nomePrefix={nomePrefix}
            isCarteiraTrabalho={isCarteiraTrabalho}
            camposBloqueados={camposBloqueados}
            getScrollableParent={getScrollableParent}
            setCarteiraSelecionada={setCarteiraSelecionada}
            setModalCarteiraAberto={setModalCarteiraAberto}
            carteiraSelecionada={carteiraSelecionada}
            carteiraTrabalho={carteiraTrabalho}
            onSalvarCarteira={salvarCarteira}
            onExcluirCarteira={excluirCarteira}
            modoSomenteLeitura={modoSomenteLeitura}
            origemCarteira ={origemCarteira}
        />
        )}
      </Row>
      {children && <Row gutter={12}>{children}</Row>}
    </>
  );
};

export default IdentificacaoBase;
